import React, {
  useCallback,
  useMemo,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  Form,
  Popconfirm,
  Input,
  DatePicker,
  message,
  notification,
  // DatePicker,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { indexBy, toDatePickerDate } from 'utils/utils2';
import { useFormList } from 'hooks/useFormList';
import ParListSelect from 'components/ParListSelect';
import { AuthContext } from 'components/Auth/Auth';
import DeleteButton from 'components/DeleteButton';
import _ from 'lodash';
import {
  getFinModificationByModid,
  getFinModificationValidByCtrid,
} from 'services/fincontract';
import FormItem from 'antd/es/form/FormItem';
import FormInput from 'components/FormInput';
import ProposalSelect from 'components/ProposalSelect';
import MGListSelect from 'pages/Configuration/Components/MGListSelect';
import InputCurrency from 'components/InputCurrency';
// import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { getParvalueByCriteria } from 'services/parametersService';
import Value from 'components/Value';
import { FormInstance } from 'antd/lib/form';
import ThirdPartyInput from 'components/ThirdPartyInput';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { PricingResponse } from 'services/pricing';
import * as finEngine from 'services/finEngine';
import moment from 'moment';
import ButtonOperation from 'components/ButtonOperation';

export type LoanRedemptionProps = {
  onSelect?: any;
  form: FormInstance;
  onSave?: (element: any) => void;
  hideButton?: boolean;
  ctstatus?: String;
};

const LoanRedemption = (props: LoanRedemptionProps) => {
  const { form, hideButton, ctstatus } = props;
  const fieldName = 'conLoanRedemption';
  const [outStanding, setOutstanding] = useState<any>(0);

  const addRow = () => {
    const currentRedemptions = form.getFieldValue(fieldName) || [];
    const newRow = {
      redempid: -Math.floor(_.random(10000) * 10000000),
      ctredtype: '',
      ctridlinked: '' as any,
      ctrid: 0,
      mgid: '' as any,
      ctredstartdate: null,
      ctredenddate: null,
      ctredremainduration: 0,
      ctredvaliditydate: null,
      ctredfinancedamount: 0,
      ctredoutstandingamount: 0,
      ctredunpaidamount: 0,
      tpofformula: '' as any,
      tpofamount: 0,
      tpoftoinvoice: 0,
      ctredtotalamount: 0,
      ctredreference: '',
      tpredbenef: '' as any,
    };
    add(newRow);
    const updatedRedemptions = [...currentRedemptions, newRow];
    form.setFieldsValue({ [fieldName]: updatedRedemptions });
  };

  const { add: add, remove: removeRedemp } = useFormList(form, fieldName, {
    idKey: 'redempid',
    addAsFirst: true,
  });

  const { isInspect } = useContext(AuthContext);

  const handleFinModSelect = async (ctrid: number, index: number) => {
    try {
      let finModificationValidResponse = await getFinModificationValidByCtrid({
        ctrid: ctrid,
        modevent: 'PREFINREIM',
      });
      if (
        finModificationValidResponse.code !== '200' &&
        finModificationValidResponse
      ) {
        notification.error({
          message: "Le contrat ne dispose pas d'une simulation valide",
        });
        console.error('Erreur lors de la recuperation des données');
        return;
      }

      const finmod = finModificationValidResponse.list[0].modid;

      let parValues = await getParvalueByCriteria({
        mgid: Number(localStorage.getItem('mgid')),
        parcode: 'VALDAYS',
        parlabel: '',
      });
      if (parValues.code !== '200' && parValues) {
        return;
      }

      let response = await getFinModificationByModid({ modid: finmod });

      if (response.code !== '200') {
        console.error('Erreur lors de la recuperation des données');
        return;
      }

      let res = response.data;

      const val = parValues.list[0];
      let parvalue = val ? val.parvaluemin : '';
      let ctredvaliditydate = res.simulParams.find(
        (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
      )?.newvalue;
      console.log('parvalue::', parvalue);
      console.log('res::', res);
      if (ctredvaliditydate) {
        const effectDate = new Date(ctredvaliditydate);
        effectDate.setDate(effectDate.getDate() + parseInt(parvalue, 10));
        ctredvaliditydate = effectDate.toISOString().slice(0, 10);
      }
      const _ctredvaliditydate = ctredvaliditydate;
      // ctredvaliditydate.setDate(ctredvaliditydate.getDate() + parseInt(parvalue,10));
      const _ctetype = res.simulParams.find(
        (item) => item.parcode === 'INPPOFFORM' && item.partype === 'IN'
      )?.newvalue;
      const tpofamount = res.simulParams.find(
        (item) => item.parcode === 'INPPOFFEES' && item.partype === 'IN'
      )?.newvalue;
      const ctredremainduration = res.simulParams.find(
        (item) => item.parcode === 'DURATION' && item.partype === 'IN'
      )?.newvalue;
      const ctredoutstandingamount = res.simulParams.find(
        (item) => item.parcode === 'INPPOFFAMT' && item.partype === 'IN'
      )?.newvalue;
      const tpofformula = res.simulParams.find(
        (item) => item.parcode === 'INPPOFFORM' && item.partype === 'IN'
      )?.newvalue;
      const ctredunpaidamount = res.simulParams.find(
        (item) => item.parcode === 'TOTUNPAID' && item.partype === 'IN'
      )?.newvalue;

      console.log(
        'totalunpaidamount:',
        ctredunpaidamount,
        'res.simukParams::',
        res.simulParams
      );

      const ee = {
        _ctredvaliditydate,
        _ctetype,
        tpofamount,
        ctredremainduration,
        tpofformula,
      };

      console.log('*******', ee);
      const redemption = form.getFieldValue(fieldName) || [];

      const updatedRedemption = redemption.map((item: any, i: any) => {
        if (i === index) {
          return {
            ...item,
            ctredvaliditydate: _ctredvaliditydate
              ? toDatePickerDate(_ctredvaliditydate)
              : null,
            tpofformula: tpofformula,
            tpofamount: Number(tpofamount),
            ctredremainduration: Number(ctredremainduration),
            ctredoutstandingamount: Number(ctredoutstandingamount),
            tpoftoinvoice: Number(tpofamount),
            _ctetype: _ctetype,
            ctredunpaidamount: Number(ctredunpaidamount),
          };
        }
        return item;
      });
      form.setFieldsValue({
        [fieldName]: updatedRedemption,
      });
      handleValueChange(index, fieldName, updatedRedemption[index]);

      console.log(
        'updatedRedemption11::',
        updatedRedemption,
        'index:',
        updatedRedemption[index]
      );
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const getNameRedemption = useCallback(
    (name: string) => (record: any) => {
      const Redemp = form.getFieldValue(fieldName);

      const index = indexBy(Redemp, 'redempid')[record.redempid];
      return [fieldName, index, name];
    },
    [form]
  );

  const handleCtredTypeChange = (index: any, value: any) => {
    const redemption = form.getFieldValue('conLoanRedemption') || [];
    const updatedRedemption = redemption.map((item: any, i: any) => {
      if (i === index) {
        return {
          ...item,
          ctredtype: value,
        };
      }
      return item;
    });
    console.log('value:::', value);
    form?.setFieldsValue({
      [fieldName[index]]: updatedRedemption,
    });
  };
  const handleCtrIdLinkedChange = (index: any, e: any) => {
    const redemption = form.getFieldValue(fieldName) || [];

    console.log('e123:', e);
    const updatedRedemption = redemption.map((item: any, i: any) => {
      if (i === index) {
        return {
          ...item,
          ctridlinked: {
            ctrid: e.ctrid,
            propreference: e.propreference,
            clientname: e.clientname,
          },
          ctredstartdate: toDatePickerDate(e.values.ctestartdate),
          ctredenddate: toDatePickerDate(e.values.cteenddate),
          ctredfinancedamount: e.values.ctfinancedamount,
          mgid: e.values.mgid,
          ctredreference: e.values.propreference,
          clientname: e.values.clientname,
          // ctredunpaidamount: e.values.totalunpaidamount,
          // tpofformula: e.values.tpofformula
        };
      }
      return item;
    });

    form.setFieldsValue({
      [fieldName]: updatedRedemption,
    });
    // handleValueChange(index, fieldName, updatedRedemption[index]);
  };

  const calculateTotalAmount = (record: any) => {
    const {
      ctredunpaidamount = 0,
      ctredoutstandingamount = 0,
      tpoftoinvoice = 0,
    } = record;
    console.log('record:', record);
    if (record.ctredtype === 'INTERNAL') {
      return Number(ctredoutstandingamount) + Number(tpoftoinvoice);
    }
    return (
      Number(ctredunpaidamount) +
      Number(ctredoutstandingamount) +
      Number(tpoftoinvoice)
    );
  };
  const handleValueChange = (index: number, fieldName: any, value: any) => {
    const redemption = form.getFieldValue(fieldName) || [];

    const updatedRedemption = redemption.map((item: any, i: any) => {
      if (i === index) {
        const updatedItem = {
          ...item,
          // [fieldName]: value,
        };

        updatedItem.ctredtotalamount = calculateTotalAmount(updatedItem);
        return updatedItem;
      }
      return item;
    });

    form.setFieldsValue({ [fieldName]: updatedRedemption });
  };
  const totalAmount = useMemo(() => {
    const redemptions = form.getFieldValue(fieldName) || [];
    if (!Array.isArray(redemptions)) {
      return 0;
    }
    return redemptions.reduce(
      (sum: any, item: any) => sum + Number(item?.ctredtotalamount || 0),
      0
    );
  }, [form.getFieldValue(fieldName)]);

  const calculateFees = (pricing?: PricingResponse, index?: number) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: [],
          inDownPayment: 0,
          inFinAmount:
            form.getFieldValue([fieldName, index, 'ctredoutstandingamount']) ??
            0,
          inFollowGP: true,
          inGPDuration: 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse?.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse?.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse?.servduration ?? '',
          inServpercentage: pricing?.serviceResponse?.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: pricing?.taxrate ?? 0,
          inDuration: 0,
          inInvestAmount:
            form.getFieldValue([fieldName, index, 'ctredoutstandingamount']) ??
            0,
          inAssetAmount: 0,
          inServperiodicity: pricing?.serviceResponse?.servperiodicity ?? '1',
          inServDurationFree:
            pricing?.serviceResponse?.servdurationdefault ?? 1,
          inStartDate: moment(Date.now()).format('YYYY-MM-DD'),
          inServbasis: pricing?.serviceResponse?.servbasis ?? '',

          inCalculatedamountbasis:
            pricing?.serviceResponse?.calculatedamountbasis ?? '',

          inMarginoncalcultedamount:
            pricing?.serviceResponse?.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse?.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);
          const redemption = form.getFieldValue(fieldName) || [];

          const updatedRedemption = redemption.map((item: any, i: any) => {
            if (i === index) {
              return {
                ...item,
                tpofamount: res.installmentamount,
                tpoftoinvoice: res.installmentamount,
              };
            }
            return item;
          });
          form.setFieldsValue({
            [fieldName]: updatedRedemption,
          });
          console.log('index::', index);
          if (index != null && index != undefined) {
            handleValueChange(index, fieldName, updatedRedemption[index]);
          }
        }
      });
  };

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'ctredtype',
        key: 'ctredtype',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={[fieldName, index, 'ctredtype']}>
              <ParListSelect
                parcode="CTORIGIN"
                onChange={(e) => handleCtredTypeChange(index, e)}
                disabled={hideButton || ctstatus === 'ACTIVE'}
              />
            </Form.Item>
          );
        },
        fixed: 'left',
        width: 100,
      },
      {
        dataIndex: 'ctridlinked',
        key: 'ctridlinked',
        render: (value, record, index) => {
          return (
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) =>
                getFieldValue([fieldName, index, 'ctredtype']) ===
                'INTERNAL' ? (
                  <FormInput noStyle name={[fieldName, index, 'ctridlinked']}>
                    <ProposalSelect
                      PropOrProd="PROD"
                      onSelected={(e: any) => {
                        handleFinModSelect(e.ctrid, index);
                        handleCtrIdLinkedChange(index, e);
                      }}
                      objectName={getFieldValue('client')?.tpname}
                      ctstatus="ACTIVE"
                      value={{
                        propreference: record?.ctredreference,
                        ctrid: record?.ctridlinked,
                        clientname: getFieldValue('client')?.tpname,
                      }}
                      // disabled={hideButton || phase==='PROD'}
                    />
                  </FormInput>
                ) : (
                  <FormInput
                    noStyle
                    name={[fieldName, index, 'ctredreference']}
                  >
                    <Input disabled={hideButton || ctstatus === 'ACTIVE'} />
                  </FormInput>
                )
              }
            </FormItem>
          );
        },
        width: 260,
      },
      {
        dataIndex: 'mgid',
        key: 'mgid',
        render: (value, record, index) => {
          return (
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput noStyle name={[fieldName, index, 'mgid']}>
                  {getFieldValue([fieldName, index, 'ctredtype']) ===
                  'INTERNAL' ? (
                    <MGListSelect allowClear />
                  ) : (
                    <Value value={Number(localStorage.getItem('mgid'))} />
                  )}
                </FormInput>
              )}
            </FormItem>
          );
        },
        width: 150,
      },
      {
        dataIndex: 'tpredbenef',
        key: 'tpredbenef',
        render: (value, record, index) => {
          return (
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput noStyle name={[fieldName, index, 'tpredbenef']}>
                  {getFieldValue([fieldName, index, 'ctredtype']) ===
                  'EXTERNAL' ? (
                    <ThirdPartyInput
                      role="CLIENT"
                      disabled={hideButton || ctstatus === 'ACTIVE'}
                      onChange={(e) =>
                        form.setFieldsValue({ tpredbenef: e.tpid })
                      }
                      value={{
                        tpid: record?.tpredbenef,
                        tpname: record?.tpredbenefname,
                        tpreference: record?.tpredbenefreference,
                      }}
                    />
                  ) : (
                    <Value />
                  )}
                </FormInput>
              )}
            </FormItem>
          );
        },
        width: 150,
      },
      {
        dataIndex: 'ctredstartdate',
        key: 'ctredstartdate',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={[fieldName, index, 'ctredstartdate']}>
              <DatePicker disabled={hideButton || ctstatus === 'ACTIVE'} />
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        dataIndex: 'ctredenddate',
        key: 'ctredenddate',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={[fieldName, index, 'ctredenddate']}>
              <DatePicker disabled={hideButton || ctstatus === 'ACTIVE'} />
            </Form.Item>
          );
        },
        width: 140,
      },

      {
        key: 'ctredremainduration',
        comcode: 'ctredremainduration',
        render: (value, record, index) => {
          const ctredOrigin = form?.getFieldValue([
            fieldName,
            index,
            'ctredtype',
          ]);
          return (
            <Form.Item name={[fieldName, index, 'ctredremainduration']} noStyle>
              {ctredOrigin === 'INTERNAL' ? (
                <Value />
              ) : (
                <Input disabled={hideButton || ctstatus === 'ACTIVE'} />
              )}
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        dataIndex: 'ctredvaliditydate',
        key: 'ctredvaliditydate',
        width: 140,
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={[fieldName, index, 'ctredvaliditydate']}>
              <DatePicker disabled={hideButton || ctstatus === 'ACTIVE'} />
            </Form.Item>
          );
        },
      },
      {
        key: 'ctredfinancedamount',
        comcode: 'ctredfinancedamount',
        render: (value, record, index) => {
          return (
            <Form.Item name={[fieldName, index, 'ctredfinancedamount']} noStyle>
              <InputCurrency
                currcode={
                  form.getFieldValue('currcode') ??
                  localStorage.getItem('currcode')
                }
                disabled={
                  form.getFieldValue([fieldName, index, 'ctredtype']) ===
                    'INTERNAL' ||
                  hideButton ||
                  ctstatus === 'ACTIVE'
                }
              />
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        key: 'ctredoutstandingamount',
        comcode: 'ctredoutstandingamount',
        render: (value, record, index) => {
          return (
            <Form.Item
              name={[fieldName, index, 'ctredoutstandingamount']}
              noStyle
            >
              <InputCurrency
                currcode={
                  form.getFieldValue('currcode') ??
                  localStorage.getItem('currcode')
                }
                disabled={
                  form.getFieldValue([fieldName, index, 'ctredtype']) ===
                    'INTERNAL' ||
                  hideButton ||
                  ctstatus === 'ACTIVE'
                }
                onChange={(value) => {
                  const redemption = form.getFieldValue(fieldName) || [];
                  const updatedTotal = calculateTotalAmount({
                    ...redemption[index],
                    ctredoutstandingamount: value,
                  });
                  redemption[index].ctredtotalamount = updatedTotal;
                  form.setFieldsValue({ [fieldName]: redemption });
                  console.log('value of oustan::', value);
                  setOutstanding(value);
                }}
              />
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        key: 'ctredunpaidamount',
        comcode: 'ctredunpaidamount',
        render: (value, record, index) => {
          return (
            <Form.Item name={[fieldName, index, 'ctredunpaidamount']} noStyle>
              <InputCurrency
                currcode={
                  form.getFieldValue('currcode') ??
                  localStorage.getItem('currcode')
                }
                disabled={
                  form.getFieldValue([fieldName, index, 'ctredtype']) ===
                    'INTERNAL' ||
                  hideButton ||
                  ctstatus === 'ACTIVE'
                }
                onChange={(value) => {
                  const redemption = form.getFieldValue(fieldName) || [];
                  const updatedTotal = calculateTotalAmount({
                    ...redemption[index],
                    ctredunpaidamount: value,
                  });
                  redemption[index].ctredtotalamount = updatedTotal;
                  form.setFieldsValue({ [fieldName]: redemption });
                }}
              />
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        dataIndex: 'tpofformula',
        key: 'tpofformula',
        render: (value, record, index) => {
          return (
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput noStyle name={[fieldName, index, 'tpofformula']}>
                  <PricingListFilteredSelect
                    allowClear
                    params={{
                      offerid: record.offerid ?? getFieldValue('offerid') ?? 0,
                      ctetype: 'TPOF',
                      prcode: record.prcode ?? getFieldValue('prcode') ?? 0,
                      entity: '',
                      entityid: 0,
                      tpid:
                        getFieldValue([fieldName, index, 'ctredtype']) ===
                        'INTERNAL'
                          ? getFieldValue('client')?.tpid
                          : getFieldValue([fieldName, index, 'tpredbenef'])
                              ?.tpid ??
                            record?.tpredbenef ??
                            0,
                    }}
                    value={getFieldValue([fieldName, index, 'tpofformula'])}
                    disabled={
                      getFieldValue([fieldName, index, 'ctredtype']) ===
                        'INTERNAL' ||
                      hideButton ||
                      ctstatus === 'ACTIVE'
                    }
                    onChange={(e) => calculateFees(e, index)}
                  />
                </FormInput>
              )}
            </FormItem>
          );
        },
        width: 190,
      },
      {
        key: 'tpofamount',
        comcode: 'tpofamount',
        render: (value, record, index) => {
          return (
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput noStyle name={[fieldName, index, 'tpofamount']}>
                  <InputCurrency
                    currcode={
                      getFieldValue('currcode') ??
                      localStorage.getItem('currcode')
                    }
                    disabled={
                      getFieldValue([fieldName, index, 'ctredtype']) ===
                        'INTERNAL' ||
                      hideButton ||
                      ctstatus === 'ACTIVE'
                    }
                  />
                </FormInput>
              )}
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        key: 'tpoftoinvoice',
        comcode: 'tpoftoinvoice',
        render: (value, record, index) => {
          return (
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput noStyle name={[fieldName, index, 'tpoftoinvoice']}>
                  <InputCurrency
                    currcode={
                      getFieldValue('currcode') ??
                      localStorage.getItem('currcode')
                    }
                    onChange={(value) => {
                      const redemption = form.getFieldValue(fieldName) || [];
                      const updatedTotal = calculateTotalAmount({
                        ...redemption[index],
                        tpoftoinvoice: value,
                      });
                      redemption[index].ctredtotalamount = updatedTotal;
                      form.setFieldsValue({ [fieldName]: redemption });
                    }}
                    disabled={hideButton || ctstatus === 'ACTIVE'}
                  />
                </FormInput>
              )}
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        key: 'ctredtotalamount',
        comcode: 'ctredtotalamount',
        render: (value, record, index) => {
          return (
            <Form.Item
              shouldUpdate
              noStyle
              name={[fieldName, index, 'ctredtotalamount']}
            >
              <InputCurrency
                currcode={
                  form.getFieldValue('currcode') ??
                  localStorage.getItem('currcode')
                }
                disabled={
                  form.getFieldValue([fieldName, index, 'ctredtype']) ===
                    'INTERNAL' ||
                  hideButton ||
                  ctstatus === 'ACTIVE'
                }
              />
            </Form.Item>
          );
        },
        width: 140,
      },
      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record, index) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removeRedemp(record?.redempid);
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: hideButton || ctstatus === 'ACTIVE' ? 'hide' : 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, removeRedemp, outStanding]
  );

  // const addRow = () => {
  //   add(row);
  // };

  useEffect(() => {
    if (form) {
      if (totalAmount) {
        form.setFieldsValue({ totalAmount: totalAmount });
      }
      form.setFieldsValue({
        [fieldName]: form.getFieldValue('conLoanRedemption'),
      });
    }
  }, [form, outStanding, totalAmount]);

  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        return (
          <DataGrid
            rowKey={(record: any) => record?.redempid}
            dataSource={getFieldValue(fieldName)}
            scroll={{ x: 'max-content' }}
            titleComcode="Liste des contrats à racheter"
            columns={columns}
            // isLoading={isFetching}
            hideFilters
            hideExtraAction={hideButton || ctstatus === 'ACTIVE' ? true : false}
            extraActions={
              <ButtonOperation
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => addRow()}
                comcode="add"
                size="small"
              />
            }
          />
        );
      }}
    </Form.Item>
  );
};

export default LoanRedemption;
